import React, { useRef } from "react";
import { connect, ConnectedProps } from "react-redux";

import avatar from "../../assets/images/avatar-temp.png";
import logo from "../../assets/images/logo.png";
import { openContentPopup, openDialog } from "../../store/actions";
import Countdown from "../Common/Countdown";
import { CHAT_TYPE } from "../../lib/enums";
import { DragescentState } from "../../store/reducers/stateType";
import { NotificationInfo } from "../../lib/types";

const ageEnd = false;

const mapSTateToProps = (state: DragescentState) => ({
  playerName: state.governorate.player.name,
  notifications: state.governorate.player.notifications,
  alliance: state.governorate.alliance,
  newPosts: state.governorate.newPosts
})

const mapDispatchToProps = (dispatch: any) => ({
  openDialogDispatch: (dialogOptions: any) => dispatch(openDialog(dialogOptions)),
  openContentPopupDispatch: (
    contentPopupOptions: any
  ) => dispatch(openContentPopup(contentPopupOptions)),
});

const connector = connect(mapSTateToProps, mapDispatchToProps);

const getCountDate = () => {
  const currentDate = new Date();

  if (currentDate.getHours() > 4) {
    currentDate.setDate(currentDate.getDate() + 1);
  }

  currentDate.setHours(4, 0, 0);

  return currentDate;
}

const CommonHeader = ({
  alliance,
  playerName,
  notifications,
  newPosts,
  openDialogDispatch,
  openContentPopupDispatch
}: ConnectedProps<typeof connector>) => {
  const helpMenuRef = useRef<HTMLAnchorElement>(null);
  const playersMenuRef = useRef<HTMLAnchorElement>(null);

  return (
    <div className="header hidden-print">
      <div className="container-fluid">
        <div className="row">
          {ageEnd
            ? <div className="col-sm-6 col-md-7 white text-bigger">
              Age is finished. Winning governorate is <em>Space2</em> and alliance
              <em>Spaceworld</em>
            </div> : <div className="col-sm-3 col-md-2 white text-bigger">
              Time to count <em><Countdown toTime={getCountDate()} hours={true} /></em>
            </div>
          }
          <div className={`col-md-5 text-right`}>
            <img src={logo} height={29} alt={"Logo"}/>
          </div>
          <div className={`col-md-5 col-sm-6 col-lg-5`}>
            <nav className="menu-wrap">
              <ul className="main-menu menu fixed-menu">
                <li className="menu-item">
                  <a href={`${process.env.REACT_APP_API_URL}/account/display`}>Account</a>
                </li>
                <li className="menu-item ">
                  <a href="https://www.dragescent.com/blog">Blog</a>
                </li>
                <li className="menu-item ">
                  <a
                    ref={helpMenuRef}
                    className="badged link"
                    onClick={() => openDialogDispatch({
                      name: "HelpMenu",
                      elementRef: helpMenuRef.current
                    })}
                  >
                    <span>HELP</span>
                  </a>
                </li>
                <li className="menu-item visible-xs-inline-block">
                  <a onClick={() => alliance && openContentPopupDispatch({
                    name: "AllianceBoard",
                    title: "Alliance board",
                    icon: "statistiky"
                  })}><i className="icon icon icon-statistiky middle"/></a>
                </li>
                <li className="menu-item visible-xs-inline-block">
                  <a
                    className={`notification ${newPosts.chat ? "minus" : ""}`}
                    onClick={() => openContentPopupDispatch({
                      name: "Chat",
                      title: `${alliance ? "Alliance" : "World"} Chat`,
                      icon: "politika",
                      type: alliance ? CHAT_TYPE.Alliance : CHAT_TYPE.Public
                    })}><i className="icon icon icon-politika middle"/></a>
                </li>
                <li className="menu-item visible-xs-inline-block">
                  <a
                    className={`notification ${newPosts.mail ? "minus" : ""}`}
                    onClick={() => openContentPopupDispatch({
                      name: "Mail",
                      title: "Mail",
                      icon: "posta"
                    })}><i className="icon icon icon-posta middle"/></a>
                </li>
                <li>
                  <a
                    ref={playersMenuRef}
                    className="link logged-user"
                    onClick={() => openDialogDispatch({
                      name: "PlayersMenu",
                      elementRef: playersMenuRef.current,
                      header: playerName,
                      classes: ["red"]
                    })}
                  >
                    <img src={avatar} alt="Dragon avatar"/>
                    {notifications.some((notification: NotificationInfo) => notification.unseen)
                    && <span className="badge"/>}
                    <span className="hidden-xs">{playerName}</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  )
};

export default connector(CommonHeader);
